
























import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ListMessages
  }
})
export default class UiBtnTableInfosUserAlter extends BaseComponent {
  @Prop()
  public dto;

  @Prop()
  public title;

  menu = false;
  items = [];

  @Watch('dto', { immediate: true })
  onDtoChange() {
    this.items = [];
    this.items.push({ label: 'Incluído por:', value: this.dto.usuarioInclusao + ' - ' + this.dto.dataInclusaoFmt });
    this.items.push({ label: 'Alterado por:', value: this.dto.usuarioAlteracao + ' - ' + this.dto.dataAlteracaoFmt });
  }
}
